export class EncodingResult {
    constructor(dataString, version) {
        this.dataString = dataString;
        this.version = version;
    }
}
